export const EMAIL_REGEXP = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const MAILTO_REGEXP = /^mailto\:(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#()?&//=]*)/
export const PHONE_REGEX = /((0[1-9]|00([\s\\.\\-]*[0-9]){3}|\+[0-9]{2}[\s\\.\\-]*[1-9])([\s\\.\\-]*[0-9]){8})/;
export const ITEM_BY_PAGE = 20;
export const DATE_FORMAT = "DD/MM/YYYY";
export const EPA_WEBSITE_URL = "https://www.entreprendre-pour-apprendre.fr/";
export const KUMULUS_SSO = '/#/live?sso=epa';
